import { router } from '@inertiajs/react';
import { Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import type { QuoteItem } from '@/types';

interface HasModel<T> { model: T }
const hasModel = <T,>(p: unknown): p is HasModel<T> =>
  typeof p === 'object' && p !== null && 'model' in (p as Record<string, unknown>);

// RevoGrid pasa 'model' que contiene el objeto de datos completo de la fila.
export const ActionsCell = (props: unknown) => {
  let item: QuoteItem;
  if (hasModel<QuoteItem>(props)) {
    item = props.model;
  } else {
    item = props as QuoteItem;
  }

  const handleDelete = () => {
    if (confirm('¿Está seguro de que desea eliminar este ítem?')) {
      router.delete(`/quote_items/${item.id}`, { preserveScroll: true });
    }
  };

  return (
    <div className="flex justify-center items-center h-full">
      <Button variant="ghost" size="icon" onClick={handleDelete} className="h-6 w-6 text-red-600">
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
};
